import React from 'react';
import { convertToHTML } from 'draft-convert';


export const styleToHTML = (style) => {
  switch (style) {
    default:
      return null;
  }
};

export const blockToHTML = (block) => {
  const blockType = block.type;
  switch (blockType) {
    case 'atomic:image': {
      const imgData = block.data;
      return {
        start: `<figure class="image"><img id="figure-image" width= "100%" src="https:${imgData.src}" alt="${block.text}" /><figcaption>`,
        end: '</figcaption></figure>',
      };
    }
    case "atomic": {
      return {
        start: '',
        end: '',
      };
    }
    default: return null;
  }
};

export const entityToHTML = (entity, originalText) => {


  switch (entity.type) {
    case 'LINK':
      return `<a href="${entity.data.url}"
       target="${entity.data.newTab ? '_blank' : '_self'}"
      rel="${entity.data.noFollow ? 'nofollow' : 'dofollow'}">
      ${originalText || (entity.data && entity.data.innerText )}
      </a>`;
    case 'EMBED':
      return (
        <blockquote className="embedly-card blockquote-container"><a className="embedly-card" href={entity.data.src} >{entity.data.src}</a></blockquote>
      );
    case 'MEDIA_UPLOAD': {
      const cap = entity.data.isLink ? `<a href=${entity.data.caption}>${entity.data.caption}</a>` : entity.data.caption;
      return `<figure class="image"><img width="100%" src="https:${entity.data.src}" /><figcaption>${cap === undefined ? '' : cap}</figcaption></figure>`
    }
    case 'IMAGE': {
      return `<p></p>`
    }
    default:
      return null;
  }
};

export const options = {
  styleToHTML,
  blockToHTML,
  entityToHTML,
};

export default (contentState, htmlOptions = options) => convertToHTML(htmlOptions)(contentState);